import { BRAND } from "@shared/brand";

/** Shell, navigation and vocabulary shared by every screen. */
export const common = {
  en: {
    appName: BRAND.en,
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
    signIn: "Sign in",
    signOut: "Sign out",
    username: "Username",
    password: "Password",
    currentPassword: "Current password",
    newPassword: "New password",
    changePassword: "Change password",
    save: "Save",
    cancel: "Cancel",
    confirmQuestion: "Confirm?",
    close: "Close",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    search: "Search",
    loading: "Loading…",
    noResults: "Nothing to show yet.",
    error: "Something went wrong",
    retry: "Try again",
    confirm: "Confirm",
    reason: "Reason",
    notes: "Notes",
    status: "Status",
    date: "Date",
    from: "From",
    to: "To",
    days: "days",
    // A counted number of days. English needs two of these six and Arabic needs
    // all six, but the key type is derived from the ENGLISH dictionary, so every
    // category has to be declared here or `days()` could not reach them.
    dayCount_zero: "{n} days",
    dayCount_one: "{n} day",
    dayCount_two: "{n} days",
    dayCount_few: "{n} days",
    dayCount_many: "{n} days",
    dayCount_other: "{n} days",
    hours: "hours",
    total: "Total",
    actions: "Actions",
    branch: "Branch",
    department: "Department",
    all: "All",
    yes: "Yes",
    no: "No",
    print: "Print",
    view: "View",
    back: "Back",
    email: "Email",
    phone: "Phone",
    navMyDashboard: "Dashboard",
    navManagementDashboard: "Management dashboard",
    navEmployees: "Employees",
    navAttendance: "Attendance",
    navLeave: "Leave",
    navRequests: "Requests",
    employee: "Employee",
    navPayroll: "Payroll",
    navLoans: "Loans",
    navDocuments: "Documents",
    navMail: "Mail Center",
    navStamp: "PDF Stamp",
    navReports: "Reports",
    navOrgChart: "Organisation chart",
    navAssistant: "AI Assistant",
    navPerformance: "Performance",
    navTasks: "Tasks",
    navCalendar: "Calendar",
    navSettings: "Settings",
    dashActiveEmployees: "active",
    dashAbsentToday: "absent today",
    dashLateToday: "late today",
    dashAwaitingDecision: "awaiting a decision",
    dashOvertimeAwaiting: "overtime awaiting approval",
    dashExpiringSoon: "Contracts expiring within 60 days",
    dashNoneExpiring: "No fixed-term contracts are due to expire in the next 60 days.",
    dashOpenSection: "Open",
    confirmTypeToProceed: "Type {word} to confirm",
    saving: "Saving…",
    thisMonth: "This month",
    dueToday: "Due today and overdue",
    navProfile: "My profile",
    navNotifications: "Notifications",
    navMyPayslips: "My payslips",
    navMyPerformance: "My performance",
    navMailSettings: "Mail settings",
    accessDenied: "Your role does not give you access to this page.",
    notFound: "That page does not exist.",
    clockZoneTitle: "Times are shown in {zone} — the zone attendance, payroll and the calendar are calculated in.",
    download: "Download",
    share: "Share",
    openInNewTab: "Open in new tab",
    previewUnsupported: "This file cannot be shown here. Download it to open it.",
    previewZoomHint: "Scroll to zoom · drag to move · double-click to reset",
  },
  ar: {
    appName: BRAND.ar,
    collapseSidebar: "طي القائمة الجانبية",
    expandSidebar: "توسيع القائمة الجانبية",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    changePassword: "تغيير كلمة المرور",
    save: "حفظ",
    cancel: "إلغاء",
    confirmQuestion: "تأكيد؟",
    close: "إغلاق",
    add: "إضافة",
    edit: "تعديل",
    delete: "حذف",
    create: "إنشاء",
    search: "بحث",
    loading: "جارٍ التحميل…",
    noResults: "لا توجد بيانات للعرض.",
    error: "حدث خطأ",
    retry: "إعادة المحاولة",
    confirm: "تأكيد",
    reason: "السبب",
    notes: "ملاحظات",
    status: "الحالة",
    date: "التاريخ",
    from: "من",
    to: "إلى",
    days: "يوم",
    // Arabic counts in six categories, and two of them do not take the numeral
    // at all — "يوم واحد", not "1 يوم". This is why "3 يوم" kept appearing.
    dayCount_zero: "{n} يوم",
    dayCount_one: "يوم واحد",
    dayCount_two: "يومان",
    dayCount_few: "{n} أيام",
    dayCount_many: "{n} يومًا",
    dayCount_other: "{n} يوم",
    hours: "ساعة",
    total: "الإجمالي",
    actions: "الإجراءات",
    branch: "الفرع",
    department: "القسم",
    all: "الكل",
    yes: "نعم",
    no: "لا",
    print: "طباعة",
    view: "عرض",
    back: "رجوع",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    navMyDashboard: "لوحتي",
    navManagementDashboard: "لوحة الإدارة",
    navEmployees: "الموظفون",
    navAttendance: "الحضور",
    navLeave: "الإجازات",
    navRequests: "الطلبات",
    employee: "الموظف",
    navPayroll: "الرواتب",
    navLoans: "السلف",
    navDocuments: "المستندات",
    navMail: "مركز المراسلات",
    navStamp: "ختم المستندات",
    navReports: "التقارير",
    navOrgChart: "الهيكل التنظيمي",
    navAssistant: "المساعد الذكي",
    navPerformance: "الأداء",
    navTasks: "المهام",
    navCalendar: "التقويم",
    navSettings: "الإعدادات",
    dashActiveEmployees: "على رأس العمل",
    dashAbsentToday: "غائب اليوم",
    dashLateToday: "متأخر اليوم",
    dashAwaitingDecision: "بانتظار القرار",
    dashOvertimeAwaiting: "عمل إضافي بانتظار الاعتماد",
    dashExpiringSoon: "عقود تنتهي خلال 60 يوماً",
    dashNoneExpiring: "لا توجد عقود محددة المدة تنتهي خلال الستين يوماً القادمة.",
    dashOpenSection: "فتح",
    confirmTypeToProceed: "اكتب {word} للتأكيد",
    saving: "جارٍ الحفظ…",
    thisMonth: "هذا الشهر",
    dueToday: "مستحق اليوم والمتأخر",
    navProfile: "ملفي الشخصي",
    navNotifications: "الإشعارات",
    navMyPayslips: "قسائم راتبي",
    navMyPerformance: "أدائي",
    navMailSettings: "إعدادات المراسلات",
    accessDenied: "صلاحياتك لا تسمح بالوصول إلى هذه الصفحة.",
    notFound: "هذه الصفحة غير موجودة.",
    clockZoneTitle: "تُعرض الأوقات بتوقيت {zone} — وهو التوقيت الذي تُحتسب به الحضور والرواتب والتقويم.",
    download: "تنزيل",
    share: "مشاركة",
    openInNewTab: "فتح في تبويب جديد",
    previewUnsupported: "لا يمكن عرض هذا الملف هنا. نزّله لفتحه.",
    previewZoomHint: "مرّر للتكبير · اسحب للتحريك · انقر مرتين لإعادة الضبط",
  },
} as const;
